var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04529 27.5236C0.651571 26.1298 0.651571 23.8702 2.04529 22.4764L23.4764 1.04529C24.8702 -0.348429 27.1298 -0.348429 28.5236 1.04529L49.9547 22.4764C51.3484 23.8702 51.3484 26.1298 49.9547 27.5236L28.5236 48.9547C27.1298 50.3484 24.8702 50.3484 23.4764 48.9547L2.04529 27.5236Z",
    fill: "#EE513B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1342 5L17 7.17115L22.5122 12.7787C22.2892 13.2653 22.1647 13.8081 22.1647 14.3805C22.1647 16.0054 23.1683 17.3919 24.5793 17.9334V31.6509C23.1683 32.1923 22.1647 33.5788 22.1647 35.2038C22.1647 37.3004 23.8354 39 25.8963 39C27.9573 39 29.628 37.3004 29.628 35.2038C29.628 33.7307 28.8032 32.4533 27.5976 31.8242V17.9521L32.8668 23.3124C32.6546 23.7892 32.5366 24.3185 32.5366 24.8759C32.5366 26.9725 34.2074 28.6721 36.2683 28.6721C38.3293 28.6721 40 26.9725 40 24.8759C40 22.7793 38.3293 21.0797 36.2683 21.0797C35.8678 21.0797 35.4821 21.1438 35.1204 21.2626L29.4614 15.5058C29.5697 15.1503 29.628 14.7722 29.628 14.3805C29.628 12.2839 27.9573 10.5842 25.8963 10.5842C25.5112 10.5842 25.1398 10.6436 24.7902 10.7538L19.1342 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.40f376be457466104f88d970de12dc1a.svg";
export { ForwardRef as ReactComponent };